import axios from "axios";
import { API_URL } from "../constants";

export const fetchSignatureTypes = (companyId) => {
  const url = `${API_URL}/${companyId}/signature-types/fetch`;
  return axios.get(url).then((response) => response.data);
};

export const addAdditionalSignature = async (companyId, payload) => {
  const url = `${API_URL}/${companyId}/signature/add-signers`;
  return axios.post(url, payload).then((response) => response.data);
};

export const fetchReminderInfo = async (companyId, fileId) => {
  const url = `${API_URL}/${companyId}/files/${fileId}/reminder-info`;
  return axios.get(url).then((response) => response.data);
};

export const updateReminderSettings = async (companyId, fileId, settings) => {
  const url = `${API_URL}/${companyId}/files/${fileId}/reminder-settings`;
  return axios.patch(url, settings).then((response) => response.data);
};

export const sendSignatureReminder = async (companyId, signatureId) => {
  const url = `${API_URL}/${companyId}/signatures/${signatureId}/send-reminder`;
  return axios.post(url).then((response) => response.data);
};
